<template>
  <div class="columns">
    <section class="section column is-2 menu-background">
      <Menu />
    </section>
    <section class="column is-10">

      <div class="navbar-custom-pc">
        <NavBar />
      </div>

      <div>
        <div class="level">
          <div class="level-left">
            <div class="level-item">
              <span class="is-size-3 has-text-weight-bold">Product</span>
              <span style="margin-left:25px">
                <b-button type="is-primary" icon-pack="fas" icon-left="fas fa-plus" @click="newProduct">New Product
                </b-button>
              </span>
            </div>
            <div class="level-item">
              <b-field>
            <b-select
                placeholder="Family"
                icon="sitemap"
                icon-pack="fas"
                @input="handleSelectFamily"
                v-model="selectedFamilyId">
                <option 
                v-for="option in family"
                :key="option.family_id"
                :value="option.family_id">
                {{ option.family_name }}
                </option>
            </b-select>
        </b-field>
            </div>
          </div>
        </div>
        <b-table :data="isEmpty ? [] : product" :sort-icon="sortIcon" :sort-icon-size="sortIconSize" icon-pack="fas"
          default-sort="index" paginated per-page="10" hoverable :loading="loading" pagination-rounded backend-filtering
          @filters-change="(input)=>searchProduct(input)" :debounce-search=500 backend-pagination
          @page-change="(a)=>pageChange(a)" :total="total" :current-page:sync="current_page">
          <b-table-column label="#" numeric v-slot="props">{{ props.row.index }}</b-table-column>

          <b-table-column field="product_name" label="Product Name" v-slot="props" searchable>
            {{ props.row.product_name }}</b-table-column>

          <b-table-column field="family_name" label="Family Name" v-slot="props">
            {{ props.row.family_name }}
          </b-table-column>

          <b-table-column field="retail_price_gamma_abstract_string" label="Purchase Price" v-slot="props">
            {{ props.row.retail_price_gamma_abstract_string }}
          </b-table-column>

          <b-table-column field="wholesale_price_abstract_string" label="Whole Sale Price" v-slot="props">
            {{ props.row.wholesale_price_abstract_string }}
          </b-table-column>
          <b-table-column field="retail_price_alpha_abstract_string" label="Retail Price(Type1)" v-slot="props">
            {{ props.row.retail_price_alpha_abstract_string }}
          </b-table-column>
          <b-table-column field="retail_price_alpha_abstract_string" label="Retail Price(Type2)" v-slot="props">
            {{ props.row.retail_price_beta_abstract_string }}
          </b-table-column>

          <b-table-column label="Edit" v-slot="props">
            <span>
              <b-button icon-pack="fas" icon-left="fas fa-edit" type="is-info" inverted @click="editProduct(props.row)">
              </b-button>
            </span>
          </b-table-column>
          <b-table-column label="Delete" v-slot="props">
            <span>
              <b-button icon-pack="fas" icon-left="fas fa-trash-alt" type="is-danger" inverted
                @click="deleteProduct(props.row)"></b-button>
            </span>
          </b-table-column>
          <template slot="empty">
            <section class="section">
              <div class="content has-text-grey has-text-centered">
                <img src="../assets/undraw_void_3ggu.svg" width="25%" />
                <p class="is-size-4 has-text-weight-semibold has-text-link">No Products</p>
              </div>
            </section>
          </template>
        </b-table>
      </div>
    </section>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import Menu from '@/components/Menu.vue'
export default {
  name: 'Product',
  data() {
    return {
      sortIcon: "arrow-up",
      sortIconSize: "is-small",
      product: [],
      isEmpty: false,
      loading: false,
      initData: [],
      total: 0,
      offset: 0,
      limit: 10,
      current_page: 1,
      family: [],
      selectedFamilyId:0,
    }
  },
  components: {
    NavBar,
    Menu
  },
  computed: {
    products() {
      return this.product
    }
  },
  mounted() {
    this.loadInitialProducts(this.offset, this.limit, this.selectedFamilyId)
    this.loadFamilies()
  },
  methods: {
    loadInitialProducts(offset, limit, selectedFamilyId) {
      this.loading = true
      this.$store.dispatch('getProducts', {offset, limit, selectedFamilyId})
        .then((response) => {
          this.product = []
          this.product.push(...response.result.product_data)
          this.total = response.result.total
          if (this.product.length > 0) {
            this.product.forEach((item, index) => {
              this.product[index].index = ((this.current_page - 1) * 10) +  ++index
            })
          }
          this.initData.push(...this.product)
        })
        .catch(() => {
          this.ToastError('Problem loading products')
        })
        .finally(() => {
          this.loading = false
        })
    },
    searchProduct(input) {
      if (input.product_name) {
        this.loading = true

        this.$store.dispatch('searchProduct', input.product_name)
          .then((response) => {
            this.product = []
            this.product.push(...response.result.product_data)
            if (this.product.length > 0) {
              this.product.forEach((item, index) => {
                this.product[index].index = ++index
              })
            }
          })
          .catch(() => {
            this.ToastError('Problem loading products')
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        this.product = []
        this.product.push(...this.initData)
      }

    },
    pageChange(page_number) {
      // if(this.current_page < page_number){
      //   this.offset+=10
      // }
      // else{
      //   this.offset-=10
      // }
      this.offset = (page_number - 1) * 10
      this.current_page = page_number
      this.loadInitialProducts(this.offset, this.limit, this.selectedFamilyId)
    },
    newProduct() {
      this.$router.push({
        name: "NewProduct"
      })
    },
    editProduct(data) {
      this.$router.push({
        name: "UpdateProduct",
        params: data
      })
    },
    deleteProduct(data) {
      this.$buefy.dialog.confirm({
        title: 'Delete Product',
        message: 'Are you sure you want to delete this product?',
        confirmText: 'Delete',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.$store.dispatch('deleteProduct', data)
            .then((response) => {
              if (response.error == 0) {
                this.ToastSuccess("Product deleted")
                this.loadInitialProducts()
              } else {
                this.ToastError("Problem deleting product")
              }
            })
            .catch(() => {
              this.ToastError("Problem deleting product")
            })
        }
      })
    },
    loadFamilies() {
      this.$store.dispatch('getWholeFamily')
        .then((response) => {
          if (response.result.family_data.length > 0) {
            this.family.push(...response.result.family_data)
          }
        }).catch(() => {
          this.ToastError('Problem loading family')
        })
    },
    handleSelectFamily() {
      this.$store.dispatch('getProductsFilterByFamily',{familyId:this.selectedFamilyId})
        .then((response) => {
          this.current_page = 1
          if (response.result.product_data.length > 0) {
            this.product = []
            this.product.push(...response.result.product_data)
            if (this.product.length > 0) {
              this.total = response.result.total
              this.product.forEach((item, index) => {
                this.product[index].index = ((this.current_page - 1) * 10) +  ++index
              })
            }
          }
        }).catch(() => {
          this.ToastError('Problem loading products')
        })
    }
  }

}
</script>

<style>
/* .menu-background{
    background-color: #26547C;
} */
</style>